import React from 'react';
import Slider from "react-slick";
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import Picture from 'Shared/Picture';

const DiscoverMoreTreatments = (props) => {
    const {
        Products,
        Title,
        isDesktop
    } = props;

    const maxSlidesToShow = isDesktop ? 5 : 4;
    const slidesToShow = Products.length > maxSlidesToShow ? maxSlidesToShow : Products.length;

    const settings = {
        infinite: true,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        lazyLoad: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: slidesToShow
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    };
    return (
        <div className="discover-more-treatments product-slider">
            <h3 className="slider-title">{Title.Value}</h3>
            <div className="products">
                <Slider {...settings}>
                    {Products.map((product) => {
                        return (
                            <LazyLoadComponent>
                                <a href={product.ProductsUrl.Value} key={product.Id}>
                                    <Picture
                                        src={[
                                            {
                                                Url: product.DetailsImage.Value + "--resize,170,170",
                                                WebpUrl: product.DetailsImage.Value + "--resize,170,170--returnTypeFile,webp"
                                            },
                                            {
                                                Url: product.DetailsImage.Value + "--resize,200,200",
                                                WebpUrl: product.DetailsImage.Value + "--resize,200,200--returnTypeFile,webp"
                                            },
                                            {
                                                Url: product.DetailsImage.Value + "--resize,170,170",
                                                WebpUrl: product.DetailsImage.Value + "--resize,170,170--returnTypeFile,webp"
                                            }
                                        ]}
                                        alt={product.DetailsImageAlt.Value}
                                    />
                                    <h3>{product.Title.Value}</h3>
                                </a>
                            </LazyLoadComponent>
                        );
                    })}
                </Slider>
            </div>
        </div>
    );
}
export default DiscoverMoreTreatments;
